import { StormDoorHandleType } from '../../common/storm-door-handle-type';

export interface IPublishLowesStormDoorHandleRequest {
    description: string;
    imageUrls: string[];
    sellingPoints: string[];
    isRejected: boolean;
    handleType: StormDoorHandleType;
}


export class PublishLowesStormDoorHandleRequest implements IPublishLowesStormDoorHandleRequest {
    public description: string = '';
    public imageUrls: string[] = [];
    public sellingPoints: string[] = [];
    public isRejected: boolean = false;
    public handleType: StormDoorHandleType = StormDoorHandleType.Indeterminate;
}


